// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__W+opJ","loaderContainer":"Login_loaderContainer__XVqq1","loader":"Login_loader__k+PVX","rotation":"Login_rotation__cK6tx"};